import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=548a5e3b&scoped=true"
import script from "./InputSelect.vue?vue&type=script&lang=js"
export * from "./InputSelect.vue?vue&type=script&lang=js"
import style0 from "./InputSelect.vue?vue&type=style&index=0&id=548a5e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548a5e3b",
  null
  
)

export default component.exports